import React from 'react'
import PropTypes from 'prop-types'

const ExternalSourceCircleIcon = (props) => {
  const {
    color1 = '#000000',
    color2 = '#000000',
    color3 = '#000000',
    bgColor = '#FFFFFF',
    classes = 'w-20',
  } = props
  return (
    <svg
      viewBox="40.7568 0.6323 110 110"
      width="110"
      height="110"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <defs>
        <clipPath id="clip0_9846_28612">
          <rect
            width="110"
            height="110"
            fill="white"
            transform="translate(40.7568 0.632324)"
          />
        </clipPath>
      </defs>
      <g
        clipPath="url(#clip0_9846_28612)"
        transform="matrix(1, 0, 0, 1, 1.4210854715202004e-14, 7.105427357601002e-15)"
      >
        <circle cx="95.2905" cy="55.166" r="54.5337" fill={bgColor} />
        <path
          d="M68.2995 38.4222C67.5753 38.956 67.457 39.3369 67.457 39.5129V39.5187C67.4599 39.6947 67.5811 40.0756 68.2995 40.6037C69.0036 41.1201 70.0943 41.6337 71.5456 42.0838C74.4367 42.9812 78.4994 43.5525 83.0383 43.5525C87.5773 43.5525 91.64 42.9812 94.5311 42.0838C95.9824 41.6337 97.0731 41.1201 97.7771 40.6037C98.5013 40.0699 98.6196 39.689 98.6196 39.513C98.6196 39.3369 98.5013 38.9561 97.7771 38.4223C97.0731 37.9058 95.9824 37.3922 94.5311 36.9421C91.6399 36.0447 87.5773 35.4734 83.0383 35.4734C78.4994 35.4734 74.4367 36.0447 71.5456 36.9421C70.0943 37.3922 69.0036 37.9058 68.2995 38.4222Z"
          fill={color1}
        />
        <path
          d="M106.124 66.6353H100.928V63.1729H106.124C107.532 63.1729 108.839 63.9057 109.572 65.1089L111.829 68.8109C111.936 68.984 112.12 69.0879 112.322 69.0879H114.152C113.996 69.639 113.912 70.2189 113.912 70.8191C113.912 71.4194 113.996 71.9993 114.152 72.5504H112.322C110.914 72.5504 109.607 71.8175 108.874 70.6143L106.618 66.9124C106.511 66.7392 106.326 66.6353 106.124 66.6353Z"
          fill={color3}
        />
        <path
          d="M116.459 57.9791H100.928V54.5166H116.459C116.304 55.0677 116.22 55.6476 116.22 56.2479C116.22 56.8481 116.304 57.4279 116.459 57.9791Z"
          fill={color3}
        />
        <path
          d="M106.124 49.4676H100.928V46.0051H106.124C106.326 46.0051 106.511 45.9012 106.618 45.7281L108.874 42.0262C109.607 40.823 110.914 40.0901 112.322 40.0901H114.152C113.996 40.6412 113.912 41.2211 113.912 41.8214C113.912 42.4216 113.996 43.0015 114.152 43.5526H112.322C112.12 43.5526 111.936 43.6565 111.829 43.8296L109.572 47.5315C108.839 48.7347 107.532 49.4676 106.124 49.4676Z"
          fill={color3}
        />
        <path
          d="M120.259 37.7812C122.49 37.7812 124.299 39.5904 124.299 41.8208C124.299 44.0513 122.49 45.8604 120.259 45.8604C118.029 45.8604 116.22 44.0513 116.22 41.8208C116.22 39.5904 118.029 37.7812 120.259 37.7812Z"
          fill={color1}
        />
        <path
          d="M122.568 52.2085C124.798 52.2085 126.607 54.0176 126.607 56.2481C126.607 58.4785 124.798 60.2876 122.568 60.2876C120.337 60.2876 118.528 58.4785 118.528 56.2481C118.528 54.0176 120.337 52.2085 122.568 52.2085Z"
          fill={color1}
        />
        <path
          d="M120.259 66.7793C122.49 66.7793 124.299 68.5884 124.299 70.8189C124.299 73.0492 122.49 74.8584 120.259 74.8584C118.029 74.8584 116.22 73.0493 116.22 70.8189C116.22 68.5885 118.029 66.7793 120.259 66.7793Z"
          fill={color1}
        />
        <path
          d="M67.4571 49.3234V42.8169C68.3833 43.3911 69.5461 43.8787 70.8619 44.2884C74.03 45.2695 78.3348 45.861 83.0379 45.861C87.7409 45.861 92.0458 45.2695 95.2139 44.2884C96.5296 43.8787 97.6924 43.3911 98.6186 42.8169V49.3234C98.6186 49.4994 98.5003 49.8803 97.7761 50.4141C97.0721 50.9306 95.9814 51.4442 94.5301 51.8943C91.6389 52.7916 87.5763 53.363 83.0374 53.363C78.4984 53.363 74.4357 52.7917 71.5446 51.8943C70.0933 51.4442 69.0026 50.9306 68.2986 50.4141C67.5801 49.8861 67.4589 49.5052 67.4561 49.3292L67.4571 49.3234Z"
          fill={color2}
        />
        <path
          d="M67.457 52.6267V59.7103C67.457 59.8863 67.5753 60.2672 68.2995 60.801C69.0036 61.3175 70.0943 61.831 71.5456 62.2812C74.4367 63.1785 78.4994 63.7498 83.0383 63.7498C87.5773 63.7498 91.64 63.1785 94.5311 62.2812C95.9824 61.831 97.0731 61.3174 97.7771 60.801C98.5013 60.2672 98.6196 59.8863 98.6196 59.7103V52.6267C97.6934 53.2009 96.5306 53.6885 95.2149 54.0983C92.0467 55.0793 87.7419 55.6708 83.0388 55.6708C78.3358 55.6708 74.0309 55.0793 70.8628 54.0983C69.5471 53.6885 68.3843 53.2009 67.4581 52.6267H67.457Z"
          fill={color1}
        />
        <path
          d="M95.2149 64.4857C96.5306 64.076 97.6934 63.5884 98.6196 63.0142V70.6748C98.6196 70.8508 98.5013 71.2316 97.7771 71.7655C97.0731 72.2819 95.9824 72.7955 94.5311 73.2457C91.6399 74.143 87.5773 74.7143 83.0383 74.7143C78.4994 74.7143 74.4367 74.143 71.5456 73.2457C70.0943 72.7955 69.0036 72.2819 68.2995 71.7655C67.5753 71.2317 67.457 70.8508 67.457 70.6748V63.0142C68.3832 63.5883 69.546 64.076 70.8618 64.4857C74.03 65.4667 78.3348 66.0582 83.0378 66.0582C87.7408 66.0582 92.0457 65.4667 95.2138 64.4857H95.2149Z"
          fill={color2}
        />
      </g>
    </svg>
  )
}

ExternalSourceCircleIcon.propTypes = {
  color1: PropTypes.string,
  color2: PropTypes.string,
  color3: PropTypes.string,
  classes: PropTypes.string,
  bgColor: PropTypes.string,
}

export default React.memo(ExternalSourceCircleIcon)
